
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPaletteDusk as ObiPaletteDuskElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-palette-dusk.js';
 
 
 

 
 export const ObiPaletteDusk = createComponent({
   react: React,
   tagName: 'obi-palette-dusk',
   elementClass: ObiPaletteDuskElement,
   events: {
     
   }
  });
 
 